module.exports = __webpack_public_path__ + "assets/img/on3-a28ec13d.png";